import weiTuoHeTong from './wei-tuo-he-tong';
import zbProject from './zb-project';


export default {
    path: 'zbproject',
    component: () => import('@layout/empty'),
    children: [
        zbProject,
        weiTuoHeTong
      
    ]
}
